import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'

import RulerIcon from '../Ruler/Ruler'
import MALogo from '../Icons/MALogo'

import './SizeGuide.scss'

const SizeGuide = () => {
    const [modalIsOpen, setIsOpen] = useState(false)
    const [width, setWidth] = useState(window.innerWidth)

    const breakpoint = 900

    const openModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    useEffect(() => {
        window.addEventListener('resize', () => setWidth(window.innerWidth))
    }, [])



    return (
        <div className="size-guide-outer">
            <div className="size-guide-inner">
                <div
                    className="size-guide-content size-guide"
                    onClick={openModal}
                >
                    <RulerIcon />
                    &nbsp;
                    <span>Size Guide</span>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    // style={customStyles}
                    appElement={document.getElementById('root')}
                >
                    <button className="close-x" title="close" onClick={closeModal}>&times;</button>
                    <div className="size-guide-header">
                        <div className="header-logo">
                            <MALogo />
                        </div>
                    </div>
                    <div className="size-guide-sections">
                        <div className="size-guide-baby">
                            <div className="dcf-overflow-x-auto" tabIndex="0">
                                <table className="dcf-table dcf-table-bordered dcf-table-striped dcf-w-100%">
                                    <caption>Baby Sizes</caption>
                                    <thead>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Baby Sizes
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Age
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Length (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Length (cm)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Weight (lb)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                Preemie
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                -
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                Up to 17
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                Up to 43
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                Up to 5
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                Newborn
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                0 – 4 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                Up to 20
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                Up to 51
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                5 - 9
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                0–3M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                4 – 8 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                18 – 23
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 58
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                9 – 12
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                0–6M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                4 – 20 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                18 –26
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 66
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                9 – 16
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                0–12M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                4 – 48 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                18 – 30
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                9 – 24
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                3–6M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                8 – 20 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                23 – 26
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                58 – 66
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                12 – 16
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                6–9M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                20 – 36 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                26 – 28
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                66 – 71
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                16 – 20
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                6–12M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                20 – 48 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                26 – 30
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                66 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                16 – 24
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                9-12M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                36 – 48 weeks
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                28 – 30
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                71 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                20 – 24
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                12-24M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                48 weeks – 2Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (in)"
                                            >
                                                30 – 33
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                76 – 84
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                24 – 30
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="size-guide-kid">
                            <div className="dcf-overflow-x-auto" tabIndex="0">
                                <table className="dcf-table dcf-table-bordered dcf-table-striped dcf-w-100%">
                                    <caption>Kid Sizes</caption>
                                    <thead>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Kid Sizes
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Age
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Height (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Length (cm)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Weight (lb)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                12–18m
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                1 – 1.5Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                30 – 31
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                Up to 43
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                24 – 27
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                18–24m
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                1.5 – 2Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                31 – 33
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                Up to 51
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                27 – 30
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                1T
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                1 – 2Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                30 – 33
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 58
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                24 – 27
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                2T
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                2 – 3Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                33 – 36
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 66
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                27 – 30
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                3T
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                3 – 4Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                36 – 39
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                46 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                30 – 35
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                4T
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                4 – 5Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                39 – 42
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                58 – 66
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                35 – 40
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                5T
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                5 – 6Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                42 – 45
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                66 – 71
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                40 – 46
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                6/7
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                6 – 7Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                45 – 50
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                66 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                46 – 55
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                8
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                8 – 9Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                50 – 54
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                71 – 76
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                55 – 70
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                10
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Age"
                                            >
                                                10 – 12Y
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Height (in)"
                                            >
                                                54 – 57
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Length (cm)"
                                            >
                                                76 – 84
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Weight (lb)"
                                            >
                                                70 – 85
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="size-guide-maternity">
                            <div className="dcf-overflow-x-auto" tabIndex="0">
                                <table className="dcf-table dcf-table-bordered dcf-table-striped dcf-w-100%">
                                    <caption>Maternity Sizes</caption>
                                    <thead>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Maternity Sizes
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Numerical
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Bust (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Waist (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Hips (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Inseam (in)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                XS/S
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                0 – 6
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                32 – 35
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                25 – 28
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                35 – 38
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                &lt; 27
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                S
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                4 – 6
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                34 – 35
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                27 – 28
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                37 – 38
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                27
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                8 – 10
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                36 – 37
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                29 – 30
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                39 – 40
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                27.5
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                M/L
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                8 – 14
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                36 – 40
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                29 – 33
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                39 – 43
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                27.5 – 28
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                L
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                12 – 14
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                38 – 40
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                31 – 33
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                41 – 43
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                28
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                XL
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Numerical"
                                            >
                                                16 – 18
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Bust (in)"
                                            >
                                                41 – 44
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                34 – 36
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                45 – 47
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                28.5
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="size-guide-adult-unisex">
                            <div className="dcf-overflow-x-auto" tabIndex="0">
                                <table className="dcf-table dcf-table-bordered dcf-table-striped dcf-w-100%">
                                    <caption>Adult Unisex Sizes</caption>
                                    <thead>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Adult Unisex
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Chest (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Waist (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Hips (in)
                                            </th>
                                            <th
                                                className="dcf-txt-center"
                                                scope="col"
                                            >
                                                Inseam (in)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                S
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Chest (in)"
                                            >
                                                33 – 35
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                33 – 35
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                34 – 36
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                29.5
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                M
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Chest (in)"
                                            >
                                                36 – 38
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                36 – 38
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                37 – 39
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                30
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                L
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Chest (in)"
                                            >
                                                39 – 42
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                39 – 42
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                39 – 41
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                30.5
                                            </td>
                                        </tr>
                                        <tr>
                                            <th
                                                className="dcf-txt-center"
                                                scope="row"
                                            >
                                                XL
                                            </th>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Chest (in)"
                                            >
                                                43 – 44
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Waist (in)"
                                            >
                                                43 – 44
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Hips (in)"
                                            >
                                                40 – 44
                                            </td>
                                            <td
                                                className="dcf-txt-center"
                                                data-label="Inseam (in)"
                                            >
                                                31
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default SizeGuide
